import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import {BANNER_TYPE, Banner, ViewProperties, useDevice} from '@lookiero/aurora';
import {useNavigate} from 'react-router-native';
import {ConfigurationApplication} from '@application/Config';
import {Path} from '../../../../modules/routing/routes.definition';
import {TEXT} from './LookInBanner.definition';
import {useFeatureFlags, useOverallInfo} from '@components/_context';
import {FEATURE_FLAGS} from 'ui/config';
import {useLookIn} from '@modules/look-in/ui/hooks/useLookIn';

interface LookInBannerProps extends ViewProperties {
  readonly rounded?: boolean;
  readonly scaled?: boolean;
}

export const LookInBanner: React.FC<LookInBannerProps> = ({rounded = true, scaled = true, ...others}) => {
  const {formatMessage} = useIntl();
  const {platform} = useDevice();
  const navigate = useNavigate();
  const featureFlags = useFeatureFlags() || {};
  const showSalesBanner = featureFlags[FEATURE_FLAGS.SALES_BANNER];
  const {salesOfferingEnabled, emitUserEvent} = useLookIn();
  const {cdnPath} = ConfigurationApplication.retrieve();
  const {segment} = useOverallInfo();

  const imageSrc = useMemo(() => `${cdnPath}/images/uaf/look-in/${segment}.webp`, [cdnPath, segment]);

  const onPress = async (): Promise<void> => {
    emitUserEvent({
      event: 'SHOP_BUTTON_CLICKED',
      payload: {
        button: salesOfferingEnabled && showSalesBanner ? 'banner-sales' : 'from_mylk_toshop',
      },
    });

    navigate(platform.web ? `${Path.LOOK_IN_HOME}?ref=orderPlaced-page` : Path.LOOK_IN_HOME);
  };

  return (
    <Banner
      pretitle={formatMessage(TEXT.SHOP_BANNER_PRETITLE)}
      title={formatMessage(TEXT.SHOP_BANNER_TITLE)}
      description={formatMessage(TEXT.SHOP_BANNER_TEXT)}
      image={{
        src: imageSrc,
      }}
      primaryButton={{
        text: formatMessage(TEXT.SHOP_BANNER_CTA),
        onPress: onPress,
      }}
      type={rounded ? BANNER_TYPE.ROUNDED : BANNER_TYPE.SQUARED}
      scaled={scaled}
      {...others}
    />
  );
};
